<template>
  <div>
    <v-row class="bradcrumb">
      <router-link :to="{ name: 'role-links' }" class="root">
        Dashboard
      </router-link>
      <span class="child">/ Evalutor Allocation</span>
    </v-row>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <br />
    <div>
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
      <v-card>
        <center class="heading">
          <h3>Evalutor Allocation</h3>
        </center>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="3">
              <v-autocomplete
                :items="exam_list"
                item-text="examname"
                item-value="id"
                v-model="data.examid"
                :rules="[(v) => !!v || 'required']"
                outlined
                dense
                label="Exam"
                @change="getcourse"
                placeholder="Select Exam"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="3"  v-if="course_list.length!=0">
              <v-autocomplete
                :items="course_list"
                item-text="coursename"
                item-value="corid"
                v-model="data.courseid"
                :rules="[(v) => !!v || 'required']"
                outlined
                dense
                label="Course"
                @change="getCount"
                placeholder="Select Course"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="3"  v-if="studentCount">
              <v-text-field
                v-model="studentCount"
                label="Student Count"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3"  v-if="studentCount">
             <v-text-field
                type="number"
                v-model="evalutorCount"
                label="Evalutor Count"
                outlined
                dense
                @change="convertNum()"
              ></v-text-field>
            </v-col>
          </v-row>
          <!-- <v-row v-if="studentCount">
            <v-col cols="12" md="12" align="center">
              <v-btn class="button"  @click="convertNum()">Save</v-btn>
            </v-col>
          </v-row> -->
          
          <v-row v-for="(item,index) in count" :key="item">
            <v-col cols="12" md="4">
              {{coursername}}
            </v-col>
            <v-col cols="12" md="6">
              <v-autocomplete
                :items="instList"
                item-text="name"
                item-value="instid"
                v-model="data.evlId[index]"
                :rules="[(v) => !!v || 'required']"
                outlined
                dense
                label="Evalutor"
                placeholder="Select Evalutor"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                type="number"
                v-model="data.allocation[index]"
                label="Evalutor Count"
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row v-if="count!=0" >
          <v-col cols="12" md="12" align="center">
              <v-btn class="button"  @click="save">Allocate</v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  data: () => ({
    snackbar_msg: "",
    snackbar: false,
    color: "",
    exam_list: [],
    course_list: [],
    studentCount:null,
    evalutorCount:null,
    count:0,
    data: {
      examid: null,
      courseid: null,
      evlId:[],
      allocation:[],
    },
    coursername:'',
    instList:[],
    totalcount:0,
  }),
  mounted() {
    this.onLoad();
  },
  methods: {
    onLoad() {
      axios
        .post("/VunetMaster/getAllocation")
        .then((res) => {
          if (res.data.msg == "200") {
            this.exam_list = res.data.exam;
            this.overlay = false;
          } else {
            this.overlay = false;
          }
        })
        .catch((error) => {});
    },
    getcourse() {
      this.overlay = true;
      this.course_list=[],
      this.studentCount=0,
      axios
        .post("/VunetMaster/getCourses",this.data)
        .then((res) => {
          if (res.data.msg == "200") {
              this.overlay = false;
              this.course_list=res.data.courses
          } else {
            this.overlay = false;
          }
        })
        .catch((error) => {});
    },
    getCount() {
      this.overlay = true;
      axios
        .post("/VunetMaster/getPaperChecker",this.data)
        .then((res) => {
          if (res.data.msg == "200") {
            this.overlay = false;
              this.studentCount=res.data.colcount
              this.instList=res.data.inst
              this.coursername=res.data.course
          } else {
            this.overlay = false;
          }
        })
        .catch((error) => {});
    },
    save() {
      this.overlay = true;
      for(let i=0;i<this.data.allocation.length;i++){
        const count=parseInt(this.data.allocation[i])
        this.totalcount=this.totalcount+count
      }
      //alert(this.totalcount)
      if(this.totalcount==this.studentCount)
      {
      axios
        .post("/VunetMaster/savePaperChecker",this.data)
        .then((res) => {
          if (res.data.msg == "200") {
            this.overlay = false;
            this.totalcount=0
            this.showSnackbar("#4CAF50", "Evaluate Successfully!!");
            this.reset()
            this.onLoad()
          } else {
            this.totalcount=0
            this.overlay = false;
          }
        })
        .catch((error) => {});
      }else{
        this.totalcount=0
        this.overlay = false;
        this.showSnackbar("#b71c1c", "Student count not match!!");
      }
    },
    convertNum()
    {
      //alert("In Count ::"+this.evalutorCount)
      this.count=parseInt(this.evalutorCount)
      //alert("In  ::"+ this.count)
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    reset() {
      this.count = 0;
      this.exam_list = [];
      this.course_list = [];
      this.studentCount=null;
      this.evalutorCount=null;
    },
  },
};
</script>

<style scoped></style>
